import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Sidebar from "../../public/sidebar/sidebar";
import Header from "../../shared/header/header";
import { getRoles, getSessionInfo } from "../../../Redux/reducer/session";
import i18next from 'i18next';
import IconAddContactIllustrativeOutline from 'canvas-core-react/lib/IconAddContactIllustrativeOutline';
import IconBillsIllustrativeOutline from 'canvas-core-react/lib/IconBillsIllustrativeOutline';

/*
 * 1. Dashboard
 * 2. Proveedores
 * 3. Facturas
 * 4. Admisiones
 */

const LOGS_MODULE_USER_TYPES_NOT_ALLOWED = ["CSA", "PRO"];

export class MainTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = { displayMobile: false };
  }

  getAvailableModules() {
    const { roles, session: { userType } } = this.props;
    var routes = [
      {
        id: "dashboard",
        path: "/providerSite/dashboard",
        label: `${i18next.t('general.navbar_menu.dashboard')}`,
        labelMobile: `${i18next.t('general.navbar_menu.dashboard')}`,
        order: 1,
      }
    ];

    Object.keys(roles).map((item) => {
      switch (item) {
        case 'MOD_RELATIONS':
          routes.push({ 
            id: 'relations',
            path: "/providerSite/relations",
            labelMobile: `${i18next.t('general.navbar_menu.relation')}`,
            order: 2,
            icon: <IconAddContactIllustrativeOutline size={30} />
          });
          break;
        case "MOD_BILL":
          routes.push({
            id: "bills",
            path: "/providerSite/bills",
            icon: <IconBillsIllustrativeOutline size={30} />,
            labelMobile: `${i18next.t('general.navbar_menu.bills')}`,
            order: 3,
          });
          break;
        case 'MOD_LOG':
          /* istanbul ignore else */
          if(!LOGS_MODULE_USER_TYPES_NOT_ALLOWED.includes(userType)){
            routes.push({
              id: "auditLogs",
              path: "/providerSite/logs",
              label: `${i18next.t('general.navbar_menu.logs')}`,
              labelMobile: `${i18next.t('general.navbar_menu.logs')}`,
              order: 5
            });
          }
          break;
      }

      return true;
    });

    routes.push({ id: "reports", path: "/providerSite/reports", labelMobile: `${i18next.t('general.navbar_menu.reports')}`, order: 6 });

    return this.orderMenu(routes);
  }

  orderMenu = (menu) => {
    for (var i = 0; i < menu.length; i++) {
      for (var z = 0; z < menu.length - i - 1; z++) {
        if (menu[z].order > menu[z + 1].order) {
          var current = menu[z];
          var next = menu[z + 1];
          menu[z] = next;
          menu[z + 1] = current;
        }
      }
    }

    return menu;
  };

  render() {
    const routes = this.getAvailableModules();
    const className = this.props.className || "";
    return (
      <Fragment>
        <Header />
        <Sidebar menuItems={routes} />
        <div className={`wrapper-container ${className}`}>
          <div className="content">{this.props.children}</div>
        </div>
      </Fragment>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    roles: getRoles(state),
    session: getSessionInfo(state),
  };
};

export default connect(
  mapStateToProps,
  null
)(MainTemplate);
